<nav aria-label="Primary navigation">
    <ul class="nav nav-pills flex-column" role="menubar" id="primaryNavigation">
        <li role="none" class="nav-item">
            <button type="button"
                    class="nav-link"
                    (click)="toggleMenu()"
                    [attr.aria-expanded]="showMenu"
                    aria-controls="primaryNavigation"
                    aria-label="Toggle navigation menu"
                    role="menuitem">
                <i class="fas fa-list" aria-hidden="true"></i> <span>Menu</span>
            </button>
        </li>

        <ng-container *ngFor="let node of navigationNodes">
            <!-- Leaf node (no children) -->
            <li *ngIf="!node.children?.length"
                [class.active]="isActive(node)"
                [ngClass]="{ 'd-none': node.mobileHidden, 'd-lg-block': node.mobileHidden }"
                role="none"
                class="nav-item">
                <a  class="nav-link"
                    role="menuitem"
                    [uiSref]="$any(node.link).uiSref"
                    [uiParams]="$any(node.link).uiParams"
                    [uiOptions]="$any(node.link).uiOptions"
                    [class.active]="isActive(node)">
                    <div class="circle">
                        <i [class]="node.icon" aria-hidden="true"></i>
                    </div>
                    {{ node.linkName }}
                </a>
            </li>

            <!-- Collapsible parent (has children) -->
            <li *ngIf="node.children?.length"
                [class.active]="isActive(node)"
                [ngClass]="{ 'd-none': node.mobileHidden, 'd-lg-block': node.mobileHidden }"
                role="none"
                class="nav-item">
                <button 
                    type="button"
                    class="nav-link"
                    (click)="toggleCollapse(node.id)"
                    [attr.aria-expanded]="!collapsedState[node.id]"
                    [attr.aria-controls]="node.id + '-menu'"
                    aria-haspopup="true"
                    role="menuitem">
                    <div class="circle">
                        <i [class]="node.icon" aria-hidden="true"></i>
                    </div>
                    {{ node.linkName }}
                    <i class="fas" [ngClass]="collapsedState[node.id] ? 'fa-chevron-down' : 'fa-chevron-up'" aria-hidden="true" style="float:right;"></i>
                </button>
                <ul class="sub-nav"
                    style="margin-bottom: 5px;"
                    [id]="node.id + '-menu'"
                    [ngbCollapse]="collapsedState[node.id]"
                    role="menu">
                    <li *ngFor="let child of node.children"
                        role="none"
                        [ngClass]="{ 'd-none': child.mobileHidden, 'd-lg-block': child.mobileHidden }">
                        <a  role="menuitem"
                            [uiSref]="$any(child.link).uiSref"
                            [uiParams]="$any(child.link).uiParams"
                            [uiOptions]="$any(child.link).uiOptions"
                            [class.active]="isActive(child)">
                            {{ child.linkName }}
                        </a>
                    </li>
                </ul>
            </li>
        </ng-container>
    </ul>
</nav>
